import { createApi } from "@reduxjs/toolkit/query/react";
import { endPoints, urlKeys } from "../../api";
import { baseQuery } from "./baseQuery";
import { formatString } from "../../utils/urlFormatting";

export const vendorsQuery = createApi({
  baseQuery,
  reducerPath: "vendorsQueries",
  endpoints: (builder) => ({
    createVendor: builder.mutation<any, any>({
      query: ({ data }) => ({
        url: `${formatString(endPoints.vendors.create)}`,
        method: "POST",
        body: data,
      }),
    }),
    getAllVendors: builder.query<any, any>({
      query: ({
        study_id,
        from = 0,
        size = -1,
        value = "",
        sort_by = "",
        sort_order = "",
        data,
      }) => ({
        url: `${formatString(endPoints.vendors.getAll, {
          key: urlKeys.study_id,
          value: encodeURIComponent(study_id),
        })}?from=${from}&size=${size}${
          value && `&value=${encodeURIComponent(value)}`
        }${sort_by && `&sort_by=${sort_by}`}${
          sort_order && `&sort_order=${sort_order}`
        }`,
        method: "POST",
        body: data,
      }),
    }),
    updateVendor: builder.mutation<any, any>({
      query: ({ data }) => ({
        url: `${formatString(endPoints.vendors.update)}`,
        method: "PUT",
        body: data,
      }),
    }),
    deleteVendor: builder.mutation<any, any>({
      query: ({ study_id, vendor_id }) => ({
        url: `${formatString(
          endPoints.vendors.delete,
          {
            key: urlKeys.study_id,
            value: encodeURIComponent(study_id),
          },
          {
            key: urlKeys.vendor_id,
            value: vendor_id,
          }
        )}`,
        method: "DELETE",
      }),
    }),
    vendorDetails: builder.query<any, any>({
      query: ({ study_id, vendor_id }) => ({
        url: `${formatString(
          endPoints.vendors.select,
          {
            key: urlKeys.study_id,
            value: encodeURIComponent(study_id),
          },
          {
            key: urlKeys.vendor_id,
            value: vendor_id,
          }
        )}`,
        method: "GET",
      }),
    }),
  }),
});

export const {
  useCreateVendorMutation,
  useLazyGetAllVendorsQuery,
  useUpdateVendorMutation,
  useDeleteVendorMutation,
  useLazyVendorDetailsQuery,
} = vendorsQuery;
